<template>
  <form-template
    :data="data"
    :blocks="blocks"
    :snackbar="snackbar"
    title="Текстовый блок"
    @save="save"
  >
    <html-field v-model="override.content"></html-field>
  </form-template>
</template>

<script>
import formMixin from "./formMixin";
import FormTemplate from "./Template";
import HtmlField from "../../InputBlock/HtmlField";

export default {
  name: "FormText",
  components: {HtmlField, FormTemplate },
  mixins: [formMixin],
  data() {
    return {
      override: {
        content: this.data.content
      }
    };
  }
};
</script>

